import { render } from "./WorldMap.vue?vue&type=template&id=1568b7ea"
import script from "./WorldMap.vue?vue&type=script&lang=js"
export * from "./WorldMap.vue?vue&type=script&lang=js"

import "./WorldMap.vue?vue&type=style&index=0&id=1568b7ea&lang=css"

import exportComponent from "/home/flow/draceo/clients/interne/projets/glitch-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__